import React, { useState, useEffect } from 'react';
import { db, collection, getDocs, doc, updateDoc } from './firebase';
import styled from 'styled-components';
import Logo from './Logo';
import { useNavigate } from 'react-router-dom';


const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;

const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
`;

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
`;

const TableCell = styled.td`
  padding: 12px 15px;
  border: 1px solid #ddd;
  text-align: center;
`;

const EditableCell = styled.input`
  width: 80%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  &:disabled {
    background-color: #f9f9f9;
  }
`;

const Button = styled.button`
  padding: 10px 20px;
  margin: 5px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  background-color: #5a8b37;
 
  
  color: white;
  font-weight: bold;
  &:hover {
    background-color: #6fa94c;
  }
  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

const ItemsDashboard = () => {
  const [items, setItems] = useState([]);
  const [editMode, setEditMode] = useState(null); // To track the item being edited
  const [editedItem, setEditedItem] = useState({}); // To store the edited values

  const isAuthenticated = localStorage.getItem('isAuthenticated'); // Check isAuthenticated from localStorage
  
  const navigate = useNavigate();

  useEffect(() => {
    if(isAuthenticated !== "true"){
      navigate('/');
    }
    const fetchItems = async () => {
    let fetchedItems  = [] ;
    
    // Salatat
    const salatatSnapshot = await  getDocs(collection(db, 'Foods', 'salatat', 'salatatCollection'));
    const salatatData = salatatSnapshot.docs.map(doc => ({ id: doc.id, path: 'Foods/salatat/salatatCollection' , ...doc.data() })).sort((a, b) => a.index - b.index);
    fetchedItems.push(...salatatData);

    // Mokabelat Berde
    const mokabelatBeredSnapshot = await  getDocs(collection(db, 'Foods', 'mokabelatBered', 'mokabelatBeredCollection'));
    const mokabelatBerdeData = mokabelatBeredSnapshot.docs.map(doc => ({ id: doc.id, path: 'Foods/mokabelatBered/mokabelatBeredCollection' , ...doc.data() })).sort((a, b) => a.index - b.index);
    fetchedItems.push(...mokabelatBerdeData);

    // Mokabele sokhon
    const  mokabelatSokhonSnapshot = await getDocs(collection(db, 'Foods', 'mokabelatSokhon', 'mokabelatSokhonCollection'));
    const mokabelatSokhonData = mokabelatSokhonSnapshot.docs.map(doc => ({ id: doc.id, path: 'Foods/mokabelatSokhon/mokabelatSokhonCollection' , ...doc.data() })).sort((a, b) => a.index - b.index);
    fetchedItems.push(...mokabelatSokhonData);

    // Bel Forn
    const belFornSnapshot = await getDocs(collection(db, 'Foods', 'belForn', 'belFornCollection'));
    const belFornData = belFornSnapshot.docs.map(doc => ({ id: doc.id, path: 'Foods/belForn/belFornCollection' , ...doc.data() })).sort((a, b) => a.index - b.index);
    fetchedItems.push(...belFornData);

    // Wajbat
    const wajbatSnapshot = await getDocs( collection(db, 'Foods', 'wajbat', 'wajbatCollection'));
    const wajbatData = wajbatSnapshot.docs.map(doc => ({ id: doc.id, path: 'Foods/wajbat/wajbatCollection' , ...doc.data() })).sort((a, b) => a.index - b.index);
    fetchedItems.push(...wajbatData);

    // Mashawi
    const  mashawiSnapshot = await getDocs(collection(db, 'Foods', 'mashawi', 'mashawiCollection'));
    const mashawiData = mashawiSnapshot.docs.map(doc => ({ id: doc.id, path: 'Foods/mashawi/mashawiCollection' , ...doc.data() })).sort((a, b) => a.index - b.index);
    fetchedItems.push(...mashawiData);

    // Nayeh
    const  nayehSnapshot = await getDocs(collection(db, 'Foods', 'nayeh', 'nayehCollection'));
    const nayehData = nayehSnapshot.docs.map(doc => ({ id: doc.id, path: 'Foods/nayeh/nayehCollection' , ...doc.data() })).sort((a, b) => a.index - b.index);
    fetchedItems.push(...nayehData);

    // Drinks
    const beveragesSnapshot = await  getDocs(collection(db, 'Drinks', 'drinks', 'drinkCollection'));
    const beveragesData = beveragesSnapshot.docs.map(doc => ({ id: doc.id, path: 'Drinks/drinks/drinkCollection' , ...doc.data() })).sort((a, b) => a.index - b.index);
    fetchedItems.push(...beveragesData);

    // Shishas
    const shishaSnapshot = await  getDocs(collection(db, 'Shishas', 'shishas', 'shishaCollection'));
    const shishaData = shishaSnapshot.docs.map(doc => ({ id: doc.id, path: 'Shishas/shishas/shishaCollection' , ...doc.data() })).sort((a, b) => a.index - b.index);
    fetchedItems.push(...shishaData);



    setItems(fetchedItems);
    };

    fetchItems();
  }, [isAuthenticated]);

//   const handleUpdateItem = async (id, field, value) => {
//     try {
//       const foodRef = firebase.firestore().collection('Foods').doc(id);
//       await foodRef.update({ [field]: value });
//       // Update the state to reflect changes
//       setItems(prevItems =>
//         prevItems.map(item => (item.id === id ? { ...item, [field]: value } : item))
//       );
//     } catch (error) {
//       console.error('Error updating document: ', error);
//     }
//   };

const handleUpdateItem = async (id,field, value) => {
    console.log("Id in handle update: " , id);
    console.log("Field in handle update: ", field);
    console.log("Value in handle update: ", value);
}

const handleEditClick = (item) => {
    setEditMode(item.id);
    setEditedItem(item);
  };

const handleSaveClick = async (id) => {
    try {
        const itemPath = editedItem.path.slice('/');
        console.log("Item Path Array: " ,itemPath);
        const fullPath = `${editedItem.path}/${editedItem.id}`;
        console.log("Full Path: ", fullPath);
       const itemRef = doc(db, fullPath);
       console.log("Item Ref: " , itemRef);
       console.log("edited item: ", {editedItem});
       const { index, name, nameAr, price } = editedItem;
       const updateData = { index, name, nameAr, price };
       console.log("Update Data: ", updateData);
       await updateDoc(itemRef, editedItem);
       setItems(prevItems => prevItems.map(item => (item.id === id ? editedItem : item)));
      console.log("Id in save: " , editedItem.id);
      console.log("path in save: ", editedItem.path)
      setEditMode(null);
      setEditedItem({});
    } catch (error) {
      console.error('Error updating document: ', error);
    }
  };

const handleCancelClick = () => {
    setEditMode(null);
    setEditedItem({});
  };

const handleInputChange = (field, value) => {
    setEditedItem({ ...editedItem, [field]: value });
  };

const handleLogOut = () => {
  window.localStorage.removeItem('isAuthenticated');
  navigate('/');
}



  return (
    // <Container>
    //   <Table>
    //     <thead>
    //       <tr>
    //         <th>Name</th>
    //         <th>Alt Name</th>
    //         <th>Price</th>
    //       </tr>
    //     </thead>
    //     <tbody>
    //       {items.map(item => (
    //         <TableRow key={item.id}>
    //           <TableCell>
    //             <EditableCell
    //               type="text"
    //               value={item.name}
    //               onChange={e => handleUpdateItem(item.id, 'name', e.target.value)}
    //             />
    //           </TableCell>
    //           <TableCell>
    //             <EditableCell
    //               type="text"
    //               value={item.nameAr}
    //               onChange={e => handleUpdateItem(item.id, 'nameAr', e.target.value)}
    //             />
    //           </TableCell>
    //           <TableCell>
    //             <EditableCell
    //               type="number"
    //               value={item.price}
    //               onChange={e => handleUpdateItem(item.id, 'price', e.target.value)}
    //             />
    //           </TableCell>
    //         </TableRow>
    //       ))}
    //     </tbody>
    //   </Table>
    // </Container>
    <Container>
        <Button onClick={() => handleLogOut()}>Log Out</Button>
        <Logo  />
        
    <Table>
      <thead>
        <tr>
          <th>Name</th>
          <th>Alt Name</th>
          <th>Price</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {items.map(item => (
          <TableRow key={item.id}>
            <TableCell>
              <EditableCell
                type="text"
                value={editMode === item.id ? editedItem.name : item.name}
                disabled={editMode !== item.id}
                onChange={e => handleInputChange('name', e.target.value)}
              />
            </TableCell>
            <TableCell>
              <EditableCell
                type="text"
                value={editMode === item.id ? editedItem.nameAr : item.nameAr}
                disabled={editMode !== item.id}
                onChange={e => handleInputChange('nameAr', e.target.value)}
              />
            </TableCell>
            <TableCell>
              <EditableCell
                type="number"
                value={editMode === item.id ? editedItem.price : item.price}
                disabled={editMode !== item.id}
                onChange={e => handleInputChange('price', e.target.value)}
              />
            </TableCell>
            <TableCell>
              {editMode === item.id ? (
                <>
                  <Button onClick={() => handleSaveClick(item.id)}>Save</Button>
                  <Button onClick={handleCancelClick}>Cancel</Button>
                </>
              ) : (
                <Button onClick={() => handleEditClick(item)}>Edit</Button>
              )}
            </TableCell>
          </TableRow>
        ))}
      </tbody>
    </Table>
  </Container>
    );
};

export default ItemsDashboard;
